import React from "react";
import { Grid, Paper, TextField } from "@mui/material";

export default function PasswordField({ register, errors }) {
  return (
    <Paper elevation={0}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}
      >
        <Grid
          item
          xs={4}
          sm={2.5}
          sx={{ fontWeight: "bold", p: "20px", pl: "20px" }}
        >
          パスワード
        </Grid>
        <Grid item xs={8} sm={9.5} sx={{ pl: "15px" }}>
          <TextField
            variant="standard"
            margin="normal"
            required
            type="password"
            {...register("password")}
            error={Boolean(errors?.password)}
            helperText={errors?.password?.message}
            fullWidth
            id="password"
            InputProps={{
              disableUnderline: true,
              style: { fontSize: 16 },
              autoComplete: "new-password",
            }}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}